import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

// Media uploads go to Firebase Storage (folder `uploads/`). Replaces the old upload.php on the web host.
// The storage rules apply the same limits: approved members only, these file types, 100 MB.
const MAX_BYTES = 100 * 1024 * 1024;

const CONTENT_TYPES = {
    jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', webp: 'image/webp',
    avif: 'image/avif', heic: 'image/heic', heif: 'image/heif', bmp: 'image/bmp',
    mp3: 'audio/mpeg', wav: 'audio/wav', ogg: 'audio/ogg', m4a: 'audio/mp4',
    mp4: 'video/mp4', webm: 'video/webm', mov: 'video/quicktime',
    glb: 'model/gltf-binary', gltf: 'model/gltf+json', fbx: 'application/octet-stream', obj: 'application/octet-stream',
};

// Uploads one file and resolves to its public link. Throws an Error with a readable message on failure.
export const uploadMedia = async (file) => {
    const ext = (file.name.split('.').pop() || '').toLowerCase();
    if (!CONTENT_TYPES[ext]) throw new Error('that file type is not allowed.');
    if (file.size > MAX_BYTES) throw new Error('that file is over the 100 MB limit.');

    const randomPart = Array.from(crypto.getRandomValues(new Uint8Array(6))).map(b => b.toString(16).padStart(2, '0')).join('');
    const fileRef = ref(storage, `uploads/${Date.now().toString(36)}_${randomPart}.${ext}`);
    try {
        await uploadBytes(fileRef, file, { contentType: CONTENT_TYPES[ext] });
        return await getDownloadURL(fileRef);
    } catch (err) {
        if (err && (err.code === 'storage/unauthorized' || err.code === 'storage/unauthenticated')) {
            throw new Error('your account is not allowed to upload.');
        }
        throw err;
    }
};
